const keyMirror = require('keymirror');

export const EVENTS = keyMirror({
    GET_PROFILE: null
});